// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__36dIY","calendarButtons":"ClockData_calendarButtons__2V-H5"};